<script setup>
import { reactive } from 'vue'
import { VForm } from 'vuetify/components/VForm'

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

const gender = [
  'Male',
  'Female',
]

const state = reactive({
  identity: {
    name: '',
    selectedGender: ref('Male'),
  },
})


const name = ref('')

// const radioGroup = ref(1)
const refForm = ref()
</script>

<template>
  <VContainer>
    <VForm ref="refForm">
      <VCard class="mb-6">
        <VCardText>
          <VRow>
            <VCol
              cols="12"
              md="6"
            >
              <AppTextField
                v-model="state.identity.name"
                label="Name"
                placeholder="Your Name"
              />
            </VCol>
            <VCol
              cols="12"
              md="6"
            >
              <div class="fo-gender">
                <label class="fo-label">Gender</label>
                <VRadioGroup
                  v-model="state.identity.selectedGender"
                  inline
                >
                  <div>
                    <VRadio
                      v-for="getGender in gender"
                      :key="getGender"
                      :label="getGender"
                      :value="getGender.toLocaleLowerCase()"
                    />
                  </div>
                </VRadioGroup>
              </div>
            </VCol>
            <VCol cols="12">
              <VBtn type="submit">
                SAVE AND RETURN
              </VBtn>
            </VCol>
          </VRow>
        </VCardText>
      </VCard>
    </VForm>
  </VContainer>
</template>
